import React, { useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Animated } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const formatCount = (n) => {
    if (!n || n === 0) return null;
    if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
    if (n >= 1000) return `${(n / 1000).toFixed(1)}K`;
    return String(n);
};

const PostActions = ({ likes, comments, reposts, onLike, onComment, onRepost, isLiked }) => {
    const [likeAnim] = useState(new Animated.Value(1));

    const handleLike = () => {
        Animated.sequence([
            Animated.spring(likeAnim, { toValue: 1.35, friction: 3, tension: 60, useNativeDriver: true }),
            Animated.spring(likeAnim, { toValue: 1, friction: 3, tension: 60, useNativeDriver: true }),
        ]).start();
        onLike?.();
    };

    const likesLabel = formatCount(likes);
    const commentsLabel = formatCount(comments);
    const repostsLabel = formatCount(reposts);

    return (
        <View style={styles.container}>
            {/* Comment */}
            <TouchableOpacity style={styles.actionItem} onPress={onComment} activeOpacity={0.7}>
                <Ionicons name="chatbubble-outline" size={18} color="#536471" />
                {commentsLabel ? <Text style={styles.count}>{commentsLabel}</Text> : null}
            </TouchableOpacity>

            {/* Repost */}
            <TouchableOpacity style={styles.actionItem} onPress={onRepost} activeOpacity={0.7}>
                <Ionicons name="repeat-outline" size={20} color="#536471" />
                {repostsLabel ? <Text style={styles.count}>{repostsLabel}</Text> : null}
            </TouchableOpacity>

            {/* Like */}
            <TouchableOpacity style={styles.actionItem} onPress={handleLike} activeOpacity={0.7}>
                <Animated.View style={{ transform: [{ scale: likeAnim }] }}>
                    <Ionicons
                        name={isLiked ? 'heart' : 'heart-outline'}
                        size={19}
                        color={isLiked ? '#F91880' : '#536471'}
                    />
                </Animated.View>
                {likesLabel ? (
                    <Text style={[styles.count, isLiked && styles.countLiked]}>{likesLabel}</Text>
                ) : null}
            </TouchableOpacity>

            {/* Share / Bookmark */}
            <TouchableOpacity style={styles.actionItem} activeOpacity={0.7}>
                <Ionicons name="bookmark-outline" size={18} color="#536471" />
            </TouchableOpacity>

        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: 8,
        paddingBottom: 12,
        justifyContent: 'flex-start',
        gap: 52,
    },
    actionItem: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 5,
    },
    count: {
        fontSize: 13,
        color: '#536471',
        fontWeight: '400',
    },
    countLiked: {
        color: '#F91880',
    },
});

export default PostActions;
